import React, { FunctionComponent } from 'react'
import { Heading } from '@afterpaytouch/core'

import styles from './styles.module.css'

interface Props {
  label?: string
  show?: boolean
  testNameSpace?: string
}

export const PrimaryTitle: FunctionComponent<Props> = ({ label = '', show = false, testNameSpace = '' }) => {
  if (!show || !label) {
    return null
  }

  return (
    <div className={styles.primaryTitle}>
      <Heading size='M' renderAs='span' bold testNameSpace={`${testNameSpace}-primary-title`}>
        {label}
      </Heading>
    </div>
  )
}
